import React from 'react';
import './partners.scss';
import { PartnersListData } from './PartnersListData';
import Marquee from 'react-fast-marquee';

const PartnersList = () => {
  return (
    <Marquee pauseOnHover={true} speed={50} gradient={false}>
      {PartnersListData.map(({ alt }, index) => (
        <img key={index} src={`clients/${index + 1}.svg`} alt={alt} />
      ))}
    </Marquee>
  );
};

export default PartnersList;
